import React, { Children, ReactElement, useState } from 'react';
import {
  TabBarItem as SherpaTabBarItem,
  TabBarItems as SherpaTabBarItems,
} from '../../../../deps/@bshgroup/component-tabbar';

export interface TabBarProps {
  /**
   * TabBarView items
   */
  children: ReactElement | ReactElement[];
  /**
   * The currently selected view, if not set, state is handled internally
   */
  selectedView?: string;
  /**
   * Callback when the selected view changes
   */
  onChange?: (view: string) => void;
}

/**
 * The `TabBar` component is used to render a tab bar.
 */
export function TabBar({
  children,
  selectedView,
  onChange,
  ...props
}: TabBarProps & Omit<Partial<React.HTMLAttributes<HTMLDivElement>>, keyof TabBarProps>) {
  const [selectedViewInternal, setSelectedViewInternal] = useState(
    (Children.toArray(children)[0] as ReactElement)?.props.id,
  );

  selectedView = selectedView ?? selectedViewInternal;

  const handleSelectedViewChange = (view: string) => {
    onChange?.(view);
    setSelectedViewInternal(view);
  };

  return (
    <div {...props}>
      <SherpaTabBarItems
        size="lg"
        variant="default"
        items={config =>
          Children.map(children, child =>
            child?.props ? (
              <SherpaTabBarItem
                {...config}
                key={child.props.id}
                active={child.props.id === selectedView}
                css={{ height: 'auto' }}
                onClick={() => handleSelectedViewChange(child.props.id)}
              >
                {child.props.title}
              </SherpaTabBarItem>
            ) : null,
          ).filter(e => e)
        }
      />
      <div>{Children.toArray(children).find(e => (e as ReactElement).props.id === selectedView)}</div>
    </div>
  );
}
